<template>
    <section id = "experience" class="blue-grey lighten-4"> 
        <div class="py-12"></div>
        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">{{$t("experienceTitle")}}</h2>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            {{$t("experienceDescription")}}
          </v-responsive>
            <v-row>
                <v-col cols="12" sm="8" offset-sm="2" xs="8" offset-md="2" md="8" offset-lg="1" lg="10" offset-xl="1" xl="10">
                    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                        <v-timeline-item
                            v-for="(item, i) in $t('timeline_data')"
                            :key="i"
                            :color="item.color"
                            small
                            >
                            <template v-slot:opposite>
                                <span
                                :class="`headline font-weight-bold ${item.color}--text`"
                                v-text="item.year"
                                ></span>
                            </template>
                            <div class="py-4">
                                <h2 :class="`headline font-weight-light mb-4 ${item.color}--text`">{{item.title}}</h2>
                                <div>
                                    {{item.description}}
                                </div>
                            </div>
                        </v-timeline-item>
                    </v-timeline>
                </v-col>
            </v-row>
        </v-container>
        <div class="py-12"></div>
    </section>
</template>
<script>
export default {
    name: 'Experience',
    components:{

    },
    data: () => ({
        timeline_data: [
            {
                color: 'pink',
                year: '2014/02-2016/01',
                title: 'Productos Cobra'
            },
            {
                color: 'blue',
                year: '2016/02-2017/12',
                title: 'MD Cloud Practice Solutions'
            },
            {
                color: 'blue',
                year: '2018/01-2018/07',
                title: 'CareCloud SAS'
            },
            {
                color: 'purple',
                year: '2018/07-2019/09',
                title: 'Memorial International'
            },
            {
                color: 'black',
                year: '2019/10-2020/04',
                title: 'Insoftar SAS'
            },
            {
                color: 'green',
                year: '2020/05-2020/08',
                title: 'MO Tecnologías'
            }
        ],
    }),
    methods:{
        
    }
}
</script>
<style lang="scss" scoped>

</style>